import { dateFormats } from '@nextinq/domain';
import React from 'react';
import TimeAgo from 'react-timeago';
import styled from 'styled-components';
import { baseColors } from '../themes/colors';

const DateWrapper = styled.span`
  display: grid;
  > time {
    font-size: 0.6em;
    color: ${baseColors.grey};
  }
`;

interface DateAttrProps {
  date: string;
}

export function DateAttr(props: DateAttrProps) {
  return (
    <DateWrapper>
      {dateFormats.short.dateTime(props.date)}
      <TimeAgo date={props.date} />
    </DateWrapper>
  );
}
